import { useContent } from '../cms/content.js';
import AppleWordmark from './AppleWordmark.jsx';

export default function Nav() {
  const cms = useContent();
  const nav = cms.nav || {
    packagesLabel: 'Packages',
    enterpriseLabel: 'Enterprise',
    vipLabel: 'VIP Club Members'
  };

  return (
    <nav className="kny-nav">
      <a href="#top" className="kny-nav-logo" aria-label="KNOW YORKER">
        <AppleWordmark />
      </a>
      <div className="kny-nav-links">
        <a
          href="#starting-kits"
          className="kny-navlink"
          style={{
            textDecoration: 'none',
            font: "500 11px/1 'JetBrains Mono',monospace",
            letterSpacing: '0.2em',
            textTransform: 'uppercase',
            color: '#8b8579'
          }}
        >
          {nav.packagesLabel}
        </a>
        <a
          href="#fee"
          className="kny-ghost"
          style={{
            textDecoration: 'none',
            font: "500 11px/1 'JetBrains Mono',monospace",
            letterSpacing: '0.16em',
            textTransform: 'uppercase',
            color: '#ece7dd',
            border: '1px solid rgba(201,168,106,0.4)',
            padding: '9px 16px',
            borderRadius: '2px'
          }}
        >
          {nav.enterpriseLabel}
        </a>
        <a
          href="#brief"
          className="kny-vip-button"
          style={{
            textDecoration: 'none',
            font: "600 11px/1 'JetBrains Mono',monospace",
            letterSpacing: '0.16em',
            textTransform: 'uppercase',
            color: '#0a0a0b',
            background: 'linear-gradient(135deg, #f6e0a6 0%, #e8c47e 50%, #cfa35d 100%)',
            padding: '10px 18px',
            borderRadius: '2px',
            boxShadow: '0 0 15px rgba(232,196,126,0.3)',
            transition: 'all 0.3s ease'
          }}
        >
          {nav.vipLabel}
        </a>
      </div>
    </nav>
  );
}
